define([
    "../hereMapsModule"
], function (hereMapsModule) {
    "use strict";

    hereMapsModule.service("hereMapsMarkersFactory", [
        "hereMapsService",
        function (hereMapsService) {
            var Here = null;
            // guarda os markers dos noisePoint da questão dos cluster
            var clusterMarkers = {
                noiseMarkersById: {},
                clusterMarkersById: {}
            };

            var m1 = require("!!url-loader?!markerclustererplus/images/m1.png");
            var m2 = require("!!url-loader?!markerclustererplus/images/m2.png");
            var m3 = require("!!url-loader?!markerclustererplus/images/m3.png");
            var m4 = require("!!url-loader?!markerclustererplus/images/m4.png");
            var m5 = require("!!url-loader?!markerclustererplus/images/m5.png");

            return {
                createMarkers: createMarkers,
                createMarker: createMarker,
                createClusterMarkersLayer: createClusterMarkersLayer,
                getClusterMarkers: getClusterMarkers,
                createDefaultIcon: createDefaultIcon,
                createSelectedIcon: createSelectedIcon
            };

            function createMarkers(markersData) {
                Here = hereMapsService.getHere();
                var markers = [];

                if (!markersData) {
                    return markers;
                }

                if(!markersData.markersPoints || markersData.markersPoints.length === 0 ) {
                    return markers;
                }

                for (var index = 0; index < markersData.markersPoints.length; index++) {
                    var currentPoint = markersData.markersPoints[index];
                    var marker = createMarker(currentPoint, markersData, index);
                    markers.push(marker);
                }
                return markers;
            }

            function createMarker(currentPoint, markersData, index) {
                if (markersData.specificCreate) {
                    return markersData.specificCreate(currentPoint, markersData, index);
                }

                var standardIcon = createIcon(currentPoint);
                currentPoint.data.icon = standardIcon.icon;
                var markerInstance = new Here.map.Marker(
                    {
                        lat: currentPoint.geographicInfo.latitude,
                        lng: currentPoint.geographicInfo.longitude
                    }, {
                        icon: standardIcon.hereIcon,
                        volatility: true,
                        data: currentPoint.data
                    }
                );

                markerInstance.draggable = markersData.draggable;
                return markerInstance;
            }

            function createIcon(currentPoint) {
                var icon = currentPoint.data.icon;
                if (!icon) {
                    return createDefaultIcon(currentPoint);
                }
                return {
                    hereIcon: new Here.map.Icon(icon, {
                        anchor: {x: 16, y: 32}
                    }),
                    icon: icon
                };
            }

            function createDefaultIcon(currentPoint) {
                Here = hereMapsService.getHere();
                var defaultStopIcon = getDefaultStopIcon(currentPoint.data);
                return {
                    hereIcon: new Here.map.Icon(defaultStopIcon, {
                        anchor: {x: 12.5, y: 12.5}
                    }),
                    icon: defaultStopIcon
                };
            }
            function createSelectedIcon(currentPoint) {
                Here = hereMapsService.getHere();
                var defaultStopIcon = getSelectedStopIcon(currentPoint.data);
                return {
                    hereIcon: new Here.map.Icon(defaultStopIcon, {
                        anchor: {x: 12.5, y: 12.5}
                    }),
                    icon: defaultStopIcon
                };
            }

            function getSelectedStopIcon(stopPointData) {
                if (!stopPointData.stop) {
                    return null;
                }
                var color = stopPointData.color;
                var stopIconText = stopPointData.stop.stopIconText;
                var textColor = "#bcffbc"; // cor do número dentro do box
                var canvas = createCanvas(25, 25);
                return drawNumberedBlueBox(canvas, color, stopIconText, textColor);
            }

            function getDefaultStopIcon(stopPointData) {
                if (!stopPointData.stop) {
                    return null;
                }
                var color = stopPointData.color;
                var stopIconText = stopPointData.stop.stopIconText;
                var textColor = "white"; // cor do número dentro do box
                var canvas = createCanvas(25, 25);
                return drawNumberedBlueBox(canvas, color, stopIconText, textColor);
            }

            function createCanvas(width, height) {
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                return canvas;
            }

            function drawNumberedBlueBox(canvas, color, text, textColor) {
                var ctx = canvas.getContext("2d");
                var stopNumberXPosition = canvas.width / 2;
                var stopNumberYPosition = canvas.height / 2 + 5;

                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.fillStyle = color; // cor de fundo do box
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                drawLinesAndText(ctx, canvas.width, canvas.height, text, "14px arial", textColor, 0.5, "center", stopNumberXPosition, stopNumberYPosition);

                return canvas.toDataURL();
            }

            function drawLinesAndText(ctx, width, height, text, textFont, strokeStyle, lineWidth, textAlign, stopNumberXPosition, stopNumberYPosition) {
                ctx.strokeStyle = "black";  // borda do box
                ctx.lineWidth = lineWidth;
                ctx.strokeRect(0, 0, width, height);

                ctx.font = textFont;
                ctx.textAlign = textAlign;

                ctx.strokeStyle = strokeStyle; // cor do texto
                ctx.strokeText(text, stopNumberXPosition, stopNumberYPosition);

                ctx.fillStyle = strokeStyle; // preenchimento do texto usa a mesma cor do contorno
                ctx.fillText(text, stopNumberXPosition, stopNumberYPosition);
            }

            // retorna os provedor e a layer com os markerClusterizaveis
            function createClusterMarkersLayer(markersData) {
                Here = hereMapsService.getHere();

                if (!markersData) {
                    return null;
                }

                // dataPoints: os pontos dos markers
                var dataPoints = markersData.clusterMarkersPoints.map(function (currentPoint) {
                    currentPoint.data.draggable = markersData.draggable;
                    return new Here.clustering.DataPoint(
                        currentPoint.geographicInfo.latitude,
                        currentPoint.geographicInfo.longitude,
                        1,
                        currentPoint.data);
                });

                var CUSTOM_THEME = {
                    // A apresentação do cluster
                    getClusterPresentation: function (cluster) {
                        var weight = cluster.getWeight();

                        var clusterIcon = createClusterIcon(weight);
                        var clusterMarker = new Here.map.Marker(cluster.getPosition(), {
                            icon: clusterIcon,
                            min: cluster.getMinZoom(),
                            max: cluster.getMaxZoom()
                        });

                        clusterMarker.setData(cluster);

                        cluster.forEachDataPoint(function (dataPoint) {
                            var model = dataPoint.getData();
                            clusterMarkers.clusterMarkersById[model.id] = dataPoint;
                        });

                        return clusterMarker;
                    },
                    // cada ponto icone do cluster individual
                    getNoisePresentation: function (noisePoint) {
                        var data = noisePoint.getData();
                        var icon = createIcon({data: data});

                        var marker = new Here.map.Marker(noisePoint.getPosition(), {
                            icon: icon.hereIcon,
                            volatility: true,
                            min: noisePoint.getMinZoom()
                        });

                        clusterMarkers.noiseMarkersById[data.id] = marker;

                        marker.draggable = data.draggable;
                        marker.setData(noisePoint);
                        return marker;
                    },
                };

                var clusteringProvider = new Here.clustering.Provider(dataPoints, {
                    clusteringOptions: {
                        eps: 60,
                        minWeight: 2
                    },
                    theme: CUSTOM_THEME
                });

                // guarda os pontos originais no próprio provider
                clusteringProvider.originalDataPoints = dataPoints;


                return {
                    layer: new Here.map.layer.ObjectLayer(clusteringProvider),
                    provider: clusteringProvider
                };

            }

            function createClusterIcon(weight) {
                var imageUrl = calculateImageUrls(weight);

                var iconWidth = 53;
                var iconHeight = 53;
                var textX = iconWidth / 2;
                var textY = (iconHeight / 2) + 5;

                var svgString =
                    "<svg width=\"" + iconWidth + "\" height=\"" + iconHeight + "\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">" +
                    "<image xlink:href=\"" + imageUrl + "\" width=\"" + iconWidth + "\" height=\"" + iconHeight + "\" x=\"0\" y=\"0\" />" +
                    "<text x=\"" + textX + "\" y=\"" + textY + "\" font-size=\"10pt\" font-family=\"Arial\" font-weight=\"bold\" text-anchor=\"middle\" fill=\"black\">" + weight + "</text>" +
                    "</svg>";

                return new Here.map.Icon(svgString, {
                    anchor: {x: textX, y: iconHeight / 2}
                });
            }

            function calculateImageUrls(weight) {
                if (weight >= 10000) return m5;
                if (weight >= 1000) return m4;
                if (weight >= 100) return m3;
                if (weight >= 10) return m2;
                return m1;
            }

            function getClusterMarkers(){
                return clusterMarkers;
            }
        }
    ]);
});